import { createReducer } from 'typesafe-actions';
import {
  createSession,
  rehydrate,
  purge,
  navigationUrl,
  setErrorAction,
  setLogRequestID,
  setPageView,
} from './actions';
import api from '../../services/analytic_api';

const INITIAL_STATE: AnalyticState = {
  guid: '',
  navigation: undefined,
  setErrorResponse: undefined,
  logRequestID: undefined,
  pageView: '',
};

const session = createReducer(INITIAL_STATE)
  .handleAction(purge, () => {
    api.setToken('');
    return INITIAL_STATE;
  })
  .handleAction(rehydrate, (state, action) => {
    api.setToken(action.payload?.analytic?.guid || '');
    return { ...state, ...action.payload?.analytic };
  })
  .handleAction(createSession.success, (state, action) => ({
    ...state,
    guid: action.payload,
  }))
  .handleAction(navigationUrl.success, (state, action) => ({
    ...state,
    navigation: action.payload,
  }))
  .handleAction(setErrorAction.success, (state, action) => ({
    ...state,
    setErrorResponse: action.payload,
  }))
  .handleAction(setErrorAction.failure, (state, action) => ({
    ...state,
    setErrorResponse: INITIAL_STATE.setErrorResponse,
  }))
  .handleAction(setLogRequestID, (state, action) => ({
    ...state,
    logRequestID: action.payload,
  }))
  .handleAction(setPageView.success, (state, action) => ({
    ...state,
    pageView: action.payload,
  }));

export default session;
